import {
  FINANCING_SERVICE_PATHS,
} from "@/content/landing/financing";

/** Pages that already render full in-page regulatory disclosure - skip compact footer band. */
const FULL_IN_PAGE_DISCLOSURE_PATHS = new Set<string>([
  "/financing",
  "/financing-i4f-how-it-works",
]);

const FINANCE_SERVICE_PAGE_PATHS = new Set<string>(Object.values(FINANCING_SERVICE_PATHS));

/** Residential service LP paths plus hub/home routes with finance content. */
const FINANCE_MENTION_PATHS = new Set<string>([
  "/",
  "/services",
  "/services/boilers-and-heating",
  ...FINANCE_SERVICE_PAGE_PATHS,
]);

export function shouldShowCompactFinanceDisclosure(pathname: string): boolean {
  if (FULL_IN_PAGE_DISCLOSURE_PATHS.has(pathname)) {
    return false;
  }
  return FINANCE_MENTION_PATHS.has(pathname);
}
